import { defineStore } from "pinia"
import AdminLockDataFetcher from "@/services/connectors/adminLockConnector"; "@/services/connectors/adminLockConnector"
import { closeToast, showLoading, showSuccess, showToastError } from "@/toastification";
import { getServerUrl } from "@/common/urls";
import { parseError } from "@/common/util";
import { AdminLock } from "@/services/entities/AdminLock";
import { MonthlyApprovalItem } from "@/services/entities/Approval/MonthlyApprovalItem";

const adminLock = new AdminLockDataFetcher(getServerUrl());

export const useAdminLockStore = defineStore("adminLock", {
   state: () => ({
    adminLock: {
        data: {} as AdminLock,
        loader: false,
    }
   }), 
   actions: {
    async loadAdminLock(
        year: number,
        month: number,
        userId: string
    ): Promise<void> {
        try {
            this.adminLock.loader = true;
            this.adminLock.data = await adminLock.getAdminLock(userId, year, month);
        } catch(e: any) {
            this.adminLock.loader = false;
        }
    },
    async updateAdminLock(locks: MonthlyApprovalItem[], actionAuthor: string) {
        try {
            this.adminLock.loader = true;
            await adminLock.updateAdminLock(locks, actionAuthor);
            showSuccess("Admin lock updated successfully");
        } catch (e: any) {
            showToastError("Failed to update admin lock: " + parseError(e));
            console.error(e);
        } finally {
            this.adminLock.loader = false;
        }
    },
   },
   getters: {
    getAll(): AdminLock {
        return this.adminLock.data;
    },
    getAllLoaded(): boolean {
        return !this.adminLock.loader;
    }
   }
});